import { QualifiedEventsMemberPurchasedOperator } from './constants';
import { QualifiedEventAttribute } from '../../types';

export const mapQualifiedEventPurchaseConditionToOperator = (
  purchaseCondition?: Pick<
    NonNullable<QualifiedEventAttribute['purchaseCondition']>,
    'operator' | 'excludeThreshold'
  >,
): QualifiedEventsMemberPurchasedOperator => {
  let operator: QualifiedEventsMemberPurchasedOperator =
    QualifiedEventsMemberPurchasedOperator.MoreThan;

  if (!purchaseCondition) {
    return operator;
  }

  if (purchaseCondition.operator === 'AT_LEAST') {
    operator = purchaseCondition.excludeThreshold
      ? QualifiedEventsMemberPurchasedOperator.MoreThan
      : QualifiedEventsMemberPurchasedOperator.MoreOrEqualTo;
  }

  if (purchaseCondition.operator === 'AT_MOST') {
    operator = purchaseCondition.excludeThreshold
      ? QualifiedEventsMemberPurchasedOperator.LessThan
      : QualifiedEventsMemberPurchasedOperator.LessThanOrEqualTo;
  }

  return operator;
};
